import { Grid, Image } from 'antd-mobile';
import React from 'react';
import Icon from '../icon';

const LogoShow = () => {
    return (
        <Grid columns={4} gap={8} className="home-logo-legend">
            <Grid.Item className="home-logo-legend-item">
                <div className="home-logo-legend-icon">
                    <Image
                        src={Icon.GOAL}
                        width={20}
                        height={20}
                        fit='cover'
                        style={{ backgroundColor: "#fff", borderRadius: '50%' }}
                    />
                </div>
                <span>进球</span>
            </Grid.Item>
            <Grid.Item className="home-logo-legend-item">
                <div className="home-logo-legend-icon">
                    <Image
                        src={Icon.PENALTY_KICK}
                        width={20}
                        height={20}
                        fit='cover'
                        style={{ backgroundColor: "#fff", borderRadius: '50%' }}
                    />
                </div>
                <span>点球</span>
            </Grid.Item>
            <Grid.Item className="home-logo-legend-item">
                <div className="home-logo-legend-icon">
                    <Image
                        src={Icon.PENALTY_NOT_SCORED}
                        width={17}
                        height={17}
                        fit='cover'
                        style={{ backgroundColor: "#fff", borderRadius: '50%' }}
                    />
                </div>
                <span>点球未进</span>
            </Grid.Item>
            <Grid.Item className="home-logo-legend-item">
                <div className="home-logo-legend-icon">
                    <Image
                        src={Icon.OWN_GOAL}
                        width={20}
                        height={20}
                        fit='cover'
                        style={{ backgroundColor: "#fff", borderRadius: '50%' }}
                    />
                </div>
                <span>乌龙球</span>
            </Grid.Item>
            {/* <Grid.Item  style={{ display: "flex", alignItems: "center", justifyContent: 'center', flexDirection: 'column' }}>
                <div style={{ height: '20px' }}>
                    <Image
                        src={Icon.ASSIST}
                        width={20}
                        height={20}
                        fit='cover'
                        style={{}}
                    />
                </div>
                <span>
                    助攻
                </span>
            </Grid.Item> */}
        </Grid>
    );
}

export default LogoShow;
